module.exports = __webpack_public_path__ + "img/openseapro.19464cb5.png";